// Shared constants/helpers for the Rate of Change (Condition Monitoring) alert feature.
// Centralises the decision/threshold magic strings so they are not duplicated across
// the chart dot, the chart tooltip and the service report.

import i18n from "i18n";

export const ALERT_DECISION = {
	ACKNOWLEDGE: "Acknowledge",
	CANCEL: "Cancel",
};

export const THRESHOLD_MODE = {
	PERCENTAGE: "P",
	ABSOLUTE: "A",
};

export const RATE_OF_CHANGE_ALERT = "Rate of Change Alert";

// True when the user rejected the reading.
export const isAlertCancelled = (decision) => decision === ALERT_DECISION.CANCEL;

// Display label for a recorded decision ("Acknowledged" / "Cancelled").
export const alertDecisionLabel = (decision) =>
	isAlertCancelled(decision)
		? i18n.t("label.cancelled")
		: i18n.t("label.acknowledged");
